import { Injectable } from '@angular/core';
import { JSONRPCService } from '@s8l/client-tree-lib';

import { serviceURL } from './service';

/** Inclusive ISO date range (yyyy-mm-dd) of an analytics request. */
export interface TutorAnalyticsRange {
  from?: string;
  to?: string;
}

/** Tutor usage of one group of tutor events (bg-ai-server `/analytics`, BSNS-24). */
export interface TutorTotals {
  module?: string;
  requests: number;
  questions: number;
  summaries: number;
  simplifications: number;
  answered: number;
  notCovered: number;
  errors: number;
  /** Distinct learners; null when below 5 (or per module). */
  learners?: number | null;
  inputTokens?: number;
  outputTokens?: number;
  costMicros?: number;
  avgLatencyMs?: number;
  p95LatencyMs?: number;
}

export interface TutorSummary {
  /** TUTOR_ENABLED of this namespace: the tutor widgets are shown only when true. */
  enabled: boolean;
  from: string;
  to: string;
  totals: TutorTotals;
  learnersHidden: boolean;
}

export interface TutorByModule {
  enabled: boolean;
  from: string;
  to: string;
  modules: TutorTotals[];
}

@Injectable({
  providedIn: 'root'
})
export class BgAiServerService extends JSONRPCService {
  public analyticsSummary(params: TutorAnalyticsRange): Promise<TutorSummary> {
    return this.message(serviceURL('BG_AI_SERVER', '/analytics'), 'summary', params);
  }

  public analyticsByModule(params: TutorAnalyticsRange): Promise<TutorByModule> {
    return this.message(serviceURL('BG_AI_SERVER', '/analytics'), 'by-module', params);
  }
}
